var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { height: "100vh" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("common.preview")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.fileType == "application/pdf"
        ? _c("iframe", {
            staticClass: "iframe",
            attrs: { src: _vm.src, frameborder: "0" },
          })
        : _vm.isImageType
        ? _c("div", {
            staticClass: "img-preview",
            style: {
              width: "100vw",
              height: "100vh",
              backgroundImage: "url(" + _vm.src + ")",
              backgroundSize: "contain",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }